import { NavbarVerticalItem } from '@siemens/element-ng/navbar-vertical';

export const navbarVerticalItems: NavbarVerticalItem[] = [
    {
        type: 'router-link',
        label: 'sidebar.home',
        icon: 'element-home',
        routerLink: 'home'
    },
    {
        type: 'router-link',
        label: 'sidebar.projects',
        icon: 'element-document',
        routerLink: 'projects'
    }
];

// No-op used for all "coming soon" admin items — prevents any navigation.
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const adminNavbarItems: NavbarVerticalItem[] = [
    { type: 'divider' },
    { type: 'header', label: 'sidebar.admin' },
    {
        type: 'action',
        label: 'sidebar.admin-themes',
        icon: 'element-palette',
        badge: 'Soon',
        action: noop
    },
    {
        type: 'router-link',
        label: 'sidebar.admin-components',
        icon: 'element-template',
        routerLink: 'admin/components'
    },
    {
        type: 'router-link',
        label: 'sidebar.admin-users',
        icon: 'element-user-group',
        routerLink: 'admin/users'
    },
    {
        type: 'router-link',
        label: 'sidebar.admin-mail-addresses',
        icon: 'element-mail',
        routerLink: 'admin/mail-identities'
    }
];
